<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="企业介绍" name="first">
      <intro />
    </el-tab-pane>
    <el-tab-pane label="建设项目" name="second">
      <project v-if="activeName === 'second'" />
    </el-tab-pane>
    <el-tab-pane label="企业荣誉" name="fifth">
      <honour v-if="activeName === 'fifth'" />
    </el-tab-pane>
    <el-tab-pane
      label="发展历程"
      name="third"
      v-if="graphic.code == '441704001000000020001'"
    >
      <fzlc v-if="activeName === 'third'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import intro from "./tab/intro";
import project from "./tab/project";
import fzlc from "./tab/fzlc";
import honour from "./tab/honour";
import { mapGetters } from "vuex";
export default {
  components: {
    intro,
    project,
    honour,
    fzlc
  },
  computed: {
    ...mapGetters(["graphic"])
  },
  watch: {
    graphic() {
      this.activeName = "first";
      this.handleZhwl();
    }
  },
  data() {
    return {
      activeName: "first",
      show: true
    };
  },
  mounted() {
    this.handleZhwl();
  },
  methods: {
    handleZhwl() {
      if (
        this.graphic.code === "4453810001" ||
        this.graphic.code === "4453810002"
      ) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
>>>.el-tabs
  height 100%
>>>.el-tabs__item
  color #fff
  font-size 16px
>>>.el-tabs__header
  margin-bottom 8px
>>>.el-tabs__nav-wrap::after
  background none
>>>.el-tabs__item:hover
  color #80E5FB
>>>.el-tabs__item.is-active
  color #80E5FB
>>>.el-tabs__active-bar
  background #80E5FB
>>>.el-tabs__content
  height calc(100% - 45px)
>>>.el-tab-pane
  height 100%
@media (max-width 1280px)
  >>>.el-tabs__item
    font-size 0.08rem
  >>>.el-tabs__header
    margin-bottom 4px
  >>>.el-tabs__item
    padding 0 10px
    height 30px
    line-height 30px
  >>>.el-tabs__content
    height calc(100% - 52px)
</style>
